import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './AccessPage.css'; // Assuming the CSS is in this file
import backgroundImage from '../../Assets/Loginbackground.png'; // Import the background image
//import NavigationBar from '../../Components/NavigationBar';
import axios from 'axios';

export default function ChangePassword() {
  const [formData, setFormData] = useState({ email: '', currentPassword: '', newPassword: '' });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.currentPassword) newErrors.currentPassword = 'Current password is required';
    if (!formData.newPassword) newErrors.newPassword = 'New password is required';
    return newErrors;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validateForm();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  try {
    const response = await axios.post(`${API_BASE_URL}/changepassword`, formData); // Adjust path to match your backend route

    if (response.data.message === "Password changed successfully") {
      alert('Password changed successfully!');
      navigate('/dashboard');
    } else {
      alert(response.data.message || 'Unexpected response');
    }
  } catch (error) {
    console.error(error);
    alert(
      error.response?.data?.message ||
      'An error occurred while changing the password.'
    );
  }
};
  return (
    <div>
       
    <div className="container-split">
      <div className="image-half">
        <img src={backgroundImage} alt="Login Background" className="login-image" />
      </div>

      <div className="form-half">
        <div className="access-container1">
          <h2 className="access-title">Change Password</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formCurrentPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="Enter Current Password"
                isInvalid={!!errors.currentPassword}
              />
              <Form.Control.Feedback type="invalid">{errors.currentPassword}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="Enter New Password"
                isInvalid={!!errors.newPassword}
              />
              <Form.Control.Feedback type="invalid">{errors.newPassword}</Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" className="button2" >
              Change Password
            </Button>
          </Form>

        </div>
      </div>
    </div>
    </div>
  );
}
